import { Bandeau, ConfirmationIntegree, Selection } from '@cc/ui';
import { useEffect, useState } from 'react';
import type { BrouillonsCapture } from './brouillons';

/** Les originaux des dossiers déjà déposés restent effaçables après déverrouillage. */
export function BrouillonsConserves({
  session,
  usage,
}: {
  session: BrouillonsCapture;
  usage: string;
}) {
  const [liste, setListe] = useState<{ usage: string; nom: string }[]>([]);
  const [choix, setChoix] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);
  useEffect(() => {
    let actif = true;
    void session
      .listerAutres(usage)
      .then((r) => {
        if (actif) setListe(r);
      })
      .catch(() => {
        if (actif) setErreur('Lecture des anciens brouillons impossible');
      });
    return () => {
      actif = false;
    };
  }, [session, usage]);
  if (!liste.length && !erreur) return null;
  return (
    <details>
      <summary>Autres originaux conservés sur cet appareil</summary>
      <p>
        Ces originaux appartiennent à votre compte dans cet espace. Leur effacement ne retire aucune
        pièce déjà déposée.
      </p>
      {erreur ? <Bandeau type="erreur">{erreur}</Bandeau> : null}
      <Selection
        libelle="Original local à effacer"
        optionVide="Choisir un original"
        value={choix}
        options={liste.map((b, i) => ({ valeur: b.usage, libelle: `${i + 1}. ${b.nom}` }))}
        disabled={enCours}
        onChange={(e) => setChoix(e.target.value)}
      />
      {choix ? (
        <ConfirmationIntegree
          libelle="Effacer cet ancien original"
          question="Effacer cet original chiffré de cet appareil ?"
          libelleConfirmer="Confirmer l’effacement local"
          enCours={enCours}
          onConfirmer={async () => {
            setEnCours(true);
            setErreur(null);
            try {
              await session.effacer(choix);
              setListe((l) => l.filter((b) => b.usage !== choix));
              setChoix('');
            } catch {
              setErreur('Effacement local impossible');
            } finally {
              setEnCours(false);
            }
          }}
        />
      ) : null}
    </details>
  );
}
